import { Link } from "react-router-dom";
import { BedDouble, Bath, Ruler, MapPin, ArrowUpRight } from "lucide-react";

export default function OpportunityCard({ opportunity, compact = false }) {
  const o = opportunity;
  return (
    <div className="card-editorial group block" data-testid={`opportunity-card-${o.slug}`}>
      <Link to={`/opportunities/${o.slug}`} className="block" aria-label={`Open ${o.title}`}>
        <div className={`relative ${compact ? "aspect-[4/3]" : "aspect-[16/10]"} overflow-hidden`}>
          <img src={o.featured_image || o.gallery?.[0]} alt={o.title} loading="lazy"
               className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.06]" />
          <div className="absolute top-3 left-3 flex gap-2">
            {o.is_featured && <span className="badge-gold badge-gold-solid border-transparent">Featured</span>}
            {o.availability_status === "coming_soon" && <span className="badge-soft">Coming Soon</span>}
          </div>
        </div>
      </Link>
      <div className="p-6">
        <div className="eyebrow text-altura-gold-dark">{o.country}{o.city ? ` · ${o.city}` : ""}</div>
        <Link to={`/opportunities/${o.slug}`} className="block">
          <h3 className="mt-2 font-editorial text-xl text-altura-charcoal leading-snug line-clamp-2 group-hover:text-altura-espresso transition-colors">{o.title}</h3>
        </Link>
        <p className="mt-2 text-sm text-altura-charcoal/70 line-clamp-2">{o.public_summary}</p>
        <div className="mt-4 flex flex-wrap items-center gap-4 text-[12px] text-altura-charcoal/70">
          {o.bedrooms ? <span className="inline-flex items-center gap-1.5"><BedDouble className="h-3.5 w-3.5 text-altura-gold-dark" />{o.bedrooms} beds</span> : null}
          {o.bathrooms ? <span className="inline-flex items-center gap-1.5"><Bath className="h-3.5 w-3.5 text-altura-gold-dark" />{o.bathrooms} baths</span> : null}
          {o.area_sqm ? <span className="inline-flex items-center gap-1.5"><Ruler className="h-3.5 w-3.5 text-altura-gold-dark" />{o.area_sqm} m²</span> : null}
          {o.area ? <span className="inline-flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5 text-altura-gold-dark" />{o.area}</span> : null}
        </div>
        <div className="mt-6">
          <Link
            to={`/opportunities/${o.slug}`}
            className="btn-gold w-full"
            data-testid={`opportunity-learn-more-${o.slug}`}
          >
            View Opportunity <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
